import React from "react";
import loadable from "@loadable/component";
import Loading from "../Loading";

const LoadableComponent = loadable(() => import("../../common/Home"), {
  fallback: (() => <Loading />)(),
});

const Component = () => <LoadableComponent />;

export default Component;
